module.exports = __webpack_public_path__ + "static/media/picture-in-picture.fd873f78.png";